import gql from 'graphql-tag';

export const USER_METADATA_FRAGMENT = gql`
  fragment UserMetadataFragment on UserMetadata {
    id
    firstLoginDate
  }
`;
